/* global API_ROOT */
/* eslint-disable import/prefer-default-export */
import { artistsRandomFetch } from '../artists'
import { testimonialRandomFetch } from '../testimonials'

export const schoolDispatchers = (dispatch) => ({
  loadRandomArtists(pageSize = 3) {
    dispatch(artistsRandomFetch({ page_size: pageSize })())
  },
  loadRandomTestimonial() {
    dispatch(testimonialRandomFetch())
  }
})
